import React, { useContext, } from 'react';
import { useSnackbar } from 'notistack';

export const ToastContext = React.createContext(null);

const { Provider } = ToastContext;
export const ToastProvider = ({ ...props }) => {
    const { enqueueSnackbar } = useSnackbar();

    const showInfoMessage = (message) => {
        const snackOptions = { variant: "info", autoHideDuration: 5000 };
        enqueueSnackbar(message, snackOptions);
    }

    const showSuccessMessage = (message) => {
        const snackOptions = { variant: "success", autoHideDuration: 5000 };
        enqueueSnackbar(message, snackOptions);
    }

    const showWarningMessage = (message) => {
        const snackOptions = { variant: "warning", autoHideDuration: 5000 };
        enqueueSnackbar(message, snackOptions);
    }

    const showErrorMessage = (message) => {
        const snackOptions = { variant: "error", autoHideDuration: 5000 };
        enqueueSnackbar(message, snackOptions);
    }

    return (
        <Provider value={{
            showInfoMessage,
            showSuccessMessage,
            showWarningMessage,
            showErrorMessage
        }}>
            {props.children}
        </Provider>
    );
}